import ScheduleWeeklyTimeSlots from './ScheduleWeeklyTimeSlots';

export default ScheduleWeeklyTimeSlots;
